import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { IUserSelectionState } from "../states/user-selection-state";
import { IDateRangeUpdate } from "../../models/interfaces/date-range-update.model.interface";
import moment from "moment";

const defaultDateFrom = moment().subtract(30, "days").startOf("day").toDate();
const defaultDateTo = moment().endOf("day").toDate();

export const state: IUserSelectionState = {
  dateFrom: defaultDateFrom,
  dateTo: defaultDateTo
};

export const getters: GetterTree<IUserSelectionState, RootState> = {
  selectedDates(state) {
    return [state.dateFrom, state.dateTo];
  }
};

export const mutations: MutationTree<IUserSelectionState> = {
  dateFrom(state, dateFrom: Date) {
    state.dateFrom = dateFrom;
  },
  dateTo(state, dateTo: Date) {
    state.dateTo = dateTo;
  }
};

export const actions: ActionTree<IUserSelectionState, RootState> = {
  async updateDate({ commit }, model: IDateRangeUpdate) {
    return new Promise((resolve, reject) => {
        commit("dateFrom", model.dateFrom);
        commit("dateTo", model.dateTo);
        resolve(true);
    });
  }
};

export const userSelectionModule: Module<IUserSelectionState, RootState> = {
  state, getters, mutations, actions, namespaced: true
};
